import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ProjectdatainstitutioninrelationApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectdatainstitutioninrelation'
    }


    /**
     * 项目分区id查询组织架构列表 (只用于组织架构，查询根节点)
     * @returns 
     */
    public getInstitutionByProjectDataId(projectDataId,institutionName){
        return this.send({projectDataId:projectDataId,institutionName:institutionName},"getInstitutionByProjectDataId",Methods.GET)
    }
    /**
     * 项目分区id查询组织架构列表(用于组织配置线路)
     */
    public getInstitutionListByProjectDataId(projectDataId){
        return this.send({projectDataId:projectDataId},"getInstitutionListByProjectDataId",Methods.GET)
    }
    
   
}